import React from 'react';
import {
  ObjectCommonSalesType,
  ObjectDepositSalesType,
  ObjectFinalCleaningSalesType,
  ObjectRentalSalesType, ObjectSalesType,
  ObjectTouristTaxSalesType
} from "../../../../types/ObjectTypes";
import {
  Accordion,
  AccordionButton,
  AccordionItem,
  AccordionPanel,
  HStack,
  Text,
  VStack,
} from '@chakra-ui/react';
import { Flex } from '@chakra-ui/layout';
import { ChevronDownIcon, ChevronUpIcon } from '@chakra-ui/icons';
import { Number } from '../../../common/Format/Number';
export interface PriceAccordionProps {
  title: string;
  objectSalesType:
    | ObjectSalesType
    | ObjectRentalSalesType
    | ObjectDepositSalesType
    | ObjectFinalCleaningSalesType
    | ObjectTouristTaxSalesType;
}
export const PriceAccordion = (props: PriceAccordionProps): JSX.Element => {
  const { title, objectSalesType } = props;
  return (
    <Accordion flex={1} m={0} p={0} width={'100%'} allowToggle>
      <AccordionItem m={0} p={0} borderWidth={0} border={'none'}>
        {({ isExpanded }) => (
          <>
            <AccordionButton m={0} p={0} textAlign={'left'}>
              <HStack alignItems={'flex-start'} width={'100%'}>
                <Flex flex={1} alignItems={'center'} gridGap={4}>
                  <Text>{title}</Text>
                  {isExpanded ? (
                    <ChevronUpIcon color={'blue.500'} fontSize="3xl" />
                  ) : (
                    <ChevronDownIcon color={'blue.500'} fontSize="3xl" />
                  )}
                </Flex>

                <Text alignSelf={'flex-end'}>
                  <Number
                    number={objectSalesType.totalPrice}
                    locales={'de-De'}
                    style={'currency'}
                    currency={'EUR'}
                  />
                </Text>
              </HStack>
            </AccordionButton>
            <AccordionPanel bg={'blue.50'} borderRadius={4} p={4} mt={4}>
              <VStack gridGap={2}>
                {objectSalesType.additionalInfo.map((info, idx) => {
                  return (
                    <HStack key={idx} alignItems={'flex-start'} width={'100%'}>
                      <Text flex={1}>{info.Title}</Text>
                      <Number
                        number={info.subTotalPrice}
                        locales={'de-De'}
                        style={'currency'}
                        currency={'EUR'}
                      />
                    </HStack>
                  );
                })}
              </VStack>
            </AccordionPanel>
          </>
        )}
      </AccordionItem>
    </Accordion>
  );
};
